<template>
  <footer class="Footer">
    <div class="container" :class="{ 'container-wider': isCheckoutStepRoute }">
      <div class="Footer_top">
        <div class="Footer_pic">
          <img src="@/assets/images/foot-logo.svg" alt="" class="Footer_pic-logo">
        </div>
        <div class="Footer_top-logo">
          <p class="tip">{{ $t('footer.top.tip', 'Blijf op de hoogte van Philips') }} </p>
          <div class="socialIcon">
            <a
              :href="socialLinks.twitter"
              target="_blank"
              @click="trackConversion({name: 'follow_us', servicename: 'twitter'})"
            >
              <app-icon name="twitter"/>
            </a>
            <a
              target="_blank"
              :href="socialLinks.facebook"
              @click="trackConversion({name: 'follow_us', servicename: 'facebook'})"
            >
              <app-icon name="facebook"/>
            </a>
            <a
              :href="socialLinks.youtube"
              target="_blank"
              @click="trackConversion({name: 'follow_us', servicename: 'youtube'})"
            >
              <app-icon name="youtube"/>
            </a>
            <a
              :href="socialLinks.linkedin"
              target="_blank"
              @click="trackConversion({name: 'follow_us', servicename: 'linkedin'})"
            >
              <app-icon name="linkedin"/>
            </a>
            <a
              :href="socialLinks.pinterest"
              target="_blank"
              @click="trackConversion({name: 'follow_us', servicename: 'pinterest'})"
            >
              <app-icon name="pinterest"/>
            </a>
            <a
              :href="socialLinks.instagram"
              target="_blank"
              @click="trackConversion({name: 'follow_us', servicename: 'instagram'})"
            >
              <app-icon name="insta"/>
            </a>
          </div>
        </div>
        <div class="Footer_top-location">
          <div class="flex Footer_top-select">
            <span class="select_label">{{ $t('footer.selectLabel.country', 'Select country') }}</span>
            <span class="selected">{{ country }} ›</span>
          </div>
          <div class="flex Footer_top-select">
            <span class="select_label">{{ $t('footer.selectLabel.site', 'Select site') }}</span>
            <span class="selected">{{ site }} ›</span>
          </div>
        </div>
      </div>
      <div class="Footer_bottom">
        <ul class="Footer_bottom-nav">
          <li v-for="item in bottomLinks" :key="item.text">
            <a :href="item.link" target="_blank"> {{ item.text }}</a>
          </li>
        </ul>
        <p>{{ copyright }}</p>
      </div>
    </div>
  </footer>
</template>

<script>
  import { detectedCulture } from '@/utilities/common/culture'

  export default {
    name: 'app-footer',
    data () {
      return {
        country: detectedCulture.name,
        site: detectedCulture.site,
        bottomLinks: [],
        socialLinks: {},
        copyright: ''
      }
    },

    computed: {
      isCheckoutStepRoute () {
        return this.$route.name === 'checkout'
      }
    },

    created () {
      this.$prismic.client.getSingle('footer', { lang: detectedCulture.code })
        .then((document) => {
          this.bottomLinks = document.data.bottom_links
          this.socialLinks = document.data.social_links[0]
          this.copyright = document.data.copyright[0].value
        })
        .catch((error) => {
          console.warn(error)
        })
    }
  }
</script>

<style lang="scss">
  .Footer {
    padding-top: .65rem;
    padding-bottom: .68rem;
    background-color: #0096ee;
    background-repeat: repeat-x;
    background-image: linear-gradient(to bottom right, #003655 0, #0066a1 50%, #0096ee 100%);
    font-weight: 400;

    .container {
      text-align: center;
      padding-left: .24rem;
      padding-right: .24rem;
    }

    &_top {
      .tip {
        color: #b3c8e6;
        line-height: .24rem;
        margin-bottom: .08rem;
      }

      &-logo {
        margin-top: .39rem;

        img {
          width: 2.1rem;
          height: .35rem;
        }
      }

      &-select {
        justify-content: center;

        label {
          color: #b3c8e6;
          align-items: center;
          display: flex;
          margin-left: .09rem;
        }

        .select_label {
          color: #b3c8e6;
          margin-right: .09rem;
        }

        span {
          color: $body-bg;
          outline: none;
          border: 0;
          background: none;
          width: auto;
          font-size: .14rem;
          padding-top: 0 !important;
          padding-bottom: 0 !important;
          text-align: right;
        }

        .selected {
          display: flex;
          position: relative;
          align-items: center;

          span {
            color: $body-bg;
            position: absolute;
            right: 0;
            top: 0;
            display: none;
          }
        }

        .select_arrow {
          display: none;
          margin-left: .05rem;
        }
      }

      &-location {
        margin-top: -.05rem;
        line-height: .24rem;
        display: none;
      }
    }

    &_bottom {
      padding-top: .52rem;

      &-nav {
        li {
          list-style: none;
          display: inline-block;
          color: $body-bg;
          line-height: .24rem;

          a {
            color: $body-bg;
            padding: 0 .05rem;
            line-height: .14rem;
            border-right: .015rem solid #fff;
          }
        }

        li:last-child a {
          border-right: none;
        }
      }

      p {
        color: #b3c8e6;
        line-height: .24rem;
      }
    }

    .socialIcon {
      margin-bottom: .14rem;

      a {
        margin-right: .12rem;
      }

      .icon {
        color: $white;
      }
    }
  }

  @include media(tablet) {
    .Footer {
      padding-top: .7rem;
      padding-bottom: .3rem;

      &_pic {
        order: 2;
      }

      // &_bottom {
      //   padding-top: .52rem;
      // }

      &_top {
        display: flex;
        align-items: center;
        justify-content: space-around;

        .tip {
          text-align: left;
        }

        &-logo {
          order: 1;
          margin-top: 0;
        }

        &-location {
          order: 3;
          display: block;
          visibility: hidden;
        }

        &-select {
          justify-content: flex-end;

          .selected {
            span {
              display: block;
            }
          }
        }

        .select_arrow {
          display: block;
        }
      }

      .socialIcon {
        margin-bottom: 0;
      }
    }
  }
</style>
